import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectGradeScale from "./routes/SubjectGradeScale";
export default store => ({
  path: "local-grades",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "./modules/LocalGradesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "localGrades",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SubjectGradeScale(store)],
});
